export default __webpack_public_path__ + "static/media/logo.5baa4226.png";